const Loader = () => {
    return (
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white z-50">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#FB6F92]"></div>
      </div>
    );
  };
  
  export default Loader;
  